// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mrRcn","top":"styles_top__HOegq","left":"styles_left__2xZJ_","description":"styles_description__3f_Gy"};